/* eslint-disable react/prop-types */
import React, { useState } from 'react';
import { ChevronDown, Calendar, MessageSquare, Users } from 'lucide-react';

const KIND_ICON = {
  event:        <Calendar      className="w-3 h-3" />,
  conversation: <MessageSquare className="w-3 h-3" />,
  alignment:    <Users         className="w-3 h-3" />,
};

const KIND_TONE = {
  event:        'bg-sky-50      text-sky-800     border-sky-200',
  conversation: 'bg-amber-50    text-amber-800   border-amber-200',
  alignment:    'bg-emerald-50  text-emerald-800 border-emerald-200',
};

/**
 * Suggested Movement Path™ — subtle, expandable insight card.
 *
 *   Surfacing historically effective movement patterns for this
 *   (ecosystem × perception state) pair. Counselor judgement remains
 *   the centre of the move — the system never decides for them.
 *
 * Default = collapsed. Click to expand. Never a CTA shout.
 */
export default function MovementPathCard({ path, compact = false }) {
  const [open, setOpen] = useState(!compact);
  if (!path || !path.steps || path.steps.length === 0) return null;
  return (
    <section
      data-testid="movement-path-card"
      className="rounded-xl border border-[#E5D6BE] bg-[#FAF1E1]/40 p-3 mt-3"
    >
      <button
        data-testid="movement-path-toggle"
        onClick={() => setOpen(o => !o)}
        className="flex items-baseline justify-between w-full text-left"
      >
        <span className="text-[10px] uppercase tracking-[0.16em] text-[#8C6239]">
          Suggested Movement Path™
          {!path.is_curated && <span className="opacity-60 normal-case tracking-normal ml-1">· generic</span>}
        </span>
        <ChevronDown className={`w-3 h-3 text-[#8C6239] transition-transform ${open ? 'rotate-180' : ''}`} />
      </button>

      {open && (
        <ol className="mt-2 space-y-1.5">
          {path.steps.map((s, i) => (
            <li key={`${s.kind}-${s.code}-${i}`}
                data-testid={`movement-step-${i}`}
                className="flex items-center gap-2">
              <span className="text-[10px] tabular-nums text-[#8A8681] w-4">
                {String(i + 1).padStart(2, '0')}
              </span>
              <span className={`text-[10px] inline-flex items-center gap-1 rounded-full border px-2 py-0.5 ${KIND_TONE[s.kind] || KIND_TONE.conversation}`}>
                {KIND_ICON[s.kind]} {s.kind}
              </span>
              <span className="text-[12px] text-[#5C3D1F]">{s.label}</span>
            </li>
          ))}
        </ol>
      )}

      {open && (
        <p className="mt-2 text-[10px] text-[#8A8681] italic">
          Surfacing historically effective patterns. Counselor judgement remains the centre of the move.
        </p>
      )}
    </section>
  );
}
